import { HARD_ERROR_CODES, type ValidationIssue } from './vacationRules';

export interface PartitionedVacationIssues {
    panelErrors: ValidationIssue[];
    panelWarnings: ValidationIssue[];
    fieldErrors: ValidationIssue[];
    fieldWarnings: ValidationIssue[];
}

const dedupeKey = (issue: ValidationIssue) => `${issue.code}|${issue.field ?? ''}`;

function dedupe(list: ValidationIssue[]): ValidationIssue[] {
    return list.filter(
        (issue, index, arr) => arr.findIndex((other) => dedupeKey(other) === dedupeKey(issue)) === index
    );
}

/**
 * Só `HARD_ERROR_CODES` (saldo insuficiente, não-elegibilidade) bloqueia o envio. As demais
 * violações de regra (fracionamento, data de início, abono na modalidade errada) já são barradas
 * antes disso pelo Zod no submit — aqui elas viram aviso, não bloqueio duplicado.
 */
export function partitionVacationIssues(
    ruleIssues: ValidationIssue[],
    advisories: ValidationIssue[]
): PartitionedVacationIssues {
    const visibleErrors = dedupe(ruleIssues.filter((issue) => HARD_ERROR_CODES.includes(issue.code)));
    const visibleWarnings = dedupe([
        ...ruleIssues.filter((issue) => !HARD_ERROR_CODES.includes(issue.code)),
        ...advisories,
    ]);

    return {
        panelErrors: visibleErrors.filter((issue) => !issue.field),
        panelWarnings: visibleWarnings.filter((issue) => !issue.field),
        fieldErrors: visibleErrors.filter((issue) => issue.field),
        fieldWarnings: visibleWarnings.filter((issue) => issue.field),
    };
}
